import { z } from 'zod';
import { Channel } from './notification.schema';

export const templateSchema = z.object({
  id: z.string(),
  appId: z.string().nullable().optional(),
  eventType: z.string(),
  channel: Channel,
  scope: z.enum(['app', 'tenant', 'system']),
  tenantId: z.string().nullable().optional(),
  version: z.number(),
  isActive: z.boolean(),
  /** `cac` cuando la fila la declara el CaC de la app: se muestra bloqueada. */
  managedBy: z.string().nullable().optional(),
  subject: z.string().nullable().optional(),
  fromName: z.string().nullable().optional(),
  fromEmail: z.string().nullable().optional(),
  replyTo: z.string().nullable().optional(),
  bodyMjml: z.string().nullable().optional(),
  bodyText: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Template = z.infer<typeof templateSchema>;

/**
 * A cleared text input yields `''`, not `undefined` — and `''` fails `.email()`,
 * so the form rejected fields the person never filled in. Treat empty as absent
 * at the edge of the schema instead of asking every caller to remember
 * (noten-ohq).
 */
const emptyToNull = (value: unknown) => (value === '' ? null : value);

/**
 * La forma del cable, SIN el refine de abajo. react-proto-kit 3 deriva de este
 * schema el de patch (`deepPartial` via `.extend()`), y zod 4 se niega a
 * extender un objeto que ya tiene refinements: `createDomainApi` explotaba al
 * cargar el modulo. El refine cruzado (bodyText | bodyMjml) es una regla del
 * FORMULARIO y vive en `templateInputSchema`, que es lo que valida el editor.
 */
export const templateInputBaseSchema = z.object({
  eventType: z
    .string()
    .min(1, 'Event type is required')
    .regex(/^[a-z][a-z0-9_]*$/, 'Must be snake_case'),
  channel: Channel,
  scope: z.enum(['app', 'tenant', 'system']),
  tenantId: z.string().nullable().optional(),
  subject: z.string().nullable().optional(),
  fromName: z.string().nullable().optional(),
  fromEmail: z.preprocess(emptyToNull, z.string().email('Invalid email').nullable().optional()),
  replyTo: z.preprocess(emptyToNull, z.string().email('Invalid email').nullable().optional()),
  bodyMjml: z.string().nullable().optional(),
  bodyText: z.string().nullable().optional(),
});

export const templateInputSchema = templateInputBaseSchema.refine(
  (data) =>
    (data.bodyText && data.bodyText.length > 0) || (data.bodyMjml && data.bodyMjml.length > 0),
  { message: 'Either bodyText or bodyMjml is required', path: ['bodyText'] },
);
export type TemplateInput = z.infer<typeof templateInputSchema>;
